module.exports = __webpack_public_path__ + "static/media/link-boomer-read.f00f9f58.png";